const lowercaseWord = (word: string): string => `${word[0].toLowerCase()}${word.slice(1)}`;

// Get lead time copy for display on checkout, ensuring first letter is lower-case
export const getCheckoutLeadTimeCopy = (leadTime: string | undefined): string => {
    return leadTime?.length ? leadTime.split(' ').map(lowercaseWord).join(' ') : '';
};
